module.exports = __webpack_public_path__ + "img/landing-map.4909fcff.svg";